import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Stack,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import Iconify from "src/components/Iconify";
import moment from "moment";
import { PriorityPopover, UserAvatar } from "src/components";
import { replacedText } from "src/utils";

export default function CheckListDialog({ open, onClose, item, title }) {
  if (!item) {
    return null;
  }
  const is_mobile_view = useMediaQuery("(max-width:600px)");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      aria-labelledby="dialog-title"
    >
      <DialogTitle className="d-flex justify-content-between align-items-center ">
        {title}
        {/* <IconButton onClick={onClose}>
          <Iconify icon="maki:cross" />
        </IconButton> */}
      </DialogTitle>
      <DialogContent sx={{ padding: "10px 24px" }}>
        <Typography dangerouslySetInnerHTML={replacedText(item.name)} />
        <hr className="divider" />
        <div className="">
          <Typography fontSize={"10px"} fontWeight={500}>
            Created By
          </Typography>
          <div
            className={is_mobile_view ? "" : "d-flex align-items-center gap-2"}
            style={{
              backgroundColor: "#F6F7F8",
              padding: "5px 10px",
              borderRadius: "4px",
              width: "max-content",
            }}
          >
            <div className="d-flex align-items-center gap-2">
              <UserAvatar
                sx={{
                  width: 25,
                  height: 25,
                }}
                image={item?.creator_profile?.image || " "}
                alt={item?.creator_profile?.first_name}
              />
              <Typography fontSize={"12px"} fontWeight={500}>
                {item?.creator_profile?.first_name ? (
                  <>
                    {item?.creator_profile?.first_name}{" "}
                    {item?.creator_profile?.last_name}
                  </>
                ) : (
                  "Not Found"
                )}
              </Typography>
            </div>
            <div className="d-flex align-items-center gap-2">
              <Typography fontSize={"12px"}>
                {moment(item?.createdAt).format("DD MMM YYYY hh:mm A")}
              </Typography>
              <PriorityPopover allowOpen={false} value={item.priority} />
            </div>
          </div>
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
